import { Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { GemstoneSize } from 'src/app/interfaces/gemstone-size';

@Injectable({
  providedIn: 'root'
})
export class StoneSizesProviderService extends APIProviderService<GemstoneSize> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Gemstones/Sizes`;
  }
}
